var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurgicalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.04,
    height: 18.875,
    viewBox: "0 0 20.04 18.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21323",
    "data-name": "Group 21323",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M4.17,9.887a1.528,1.528,0,0,0,.217-.5,1.517,1.517,0,0,0-.633.127L0,11.143.7,9.423,4.215,7.892a1.5,1.5,0,0,1,.256-.8l3.465-5.2A4.248,4.248,0,0,1,12.269.076L8.224,6.148l6.617-2.879a4.24,4.24,0,0,1-2.558,3.945L6.554,9.7a1.51,1.51,0,0,1-.778.117L3.717,12.913,1.9,13.294Z",
    transform: "translate(5.199 0)",
    fill: "#dedfe0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17051",
    "data-name": "Group 17051",
    transform: "translate(0 6.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25566",
    "data-name": "Path 25566",
    d: "M19.837,49.777a2.6,2.6,0,1,1,3.609-.722A2.6,2.6,0,0,1,19.837,49.777Zm2.3-3.459a1.558,1.558,0,1,0,.436,2.16A1.56,1.56,0,0,0,22.141,46.317Z",
    transform: "translate(-13.48 -37.89)",
    fill: "#1a4059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25568",
    "data-name": "Path 25568",
    d: "M2.564,22.348A2.6,2.6,0,1,1,1.218,25.77,2.6,2.6,0,0,1,2.564,22.348Zm.416.956a1.558,1.558,0,1,0,2.047.808A1.563,1.563,0,0,0,2.98,23.3Z",
    transform: "translate(-1.003 -22.133)",
    fill: "#1a4059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38621",
    "data-name": "Path 38621",
    d: "M33.883,28.932a.51.51,0,1,1-.144-.707A.512.512,0,0,1,33.883,28.932Z",
    transform: "translate(-23.292 -26.43)",
    fill: "#1a4059"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgicalLogo);
export default __webpack_public_path__ + "static/media/SurgicalLogo.25f17614350640f0b035a82cf5bd34af.svg";
export { ForwardRef as ReactComponent };